export type MileageValue = {
  value: number;
  unit: MileageValue.unit;
};

export namespace MileageValue {
  export enum unit {
    KM = 'km',
  }
}
